export const C = {
	SOCKET_URL: import.meta.env.DEV
		? 'ws://localhost:8001'
		: `wss://${import.meta.env.VITE_SERVER_URL_PROD}`,
};
